module.exports = __webpack_public_path__ + "img/毛毛雨细雨.4c58c65b.png";